import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import FrmSubscriptionCheck from '../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../RestAPI/PartnerSubscription/FrmSubscription';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import Axios from 'axios';
import { saveAs } from 'file-saver';
import AlertMessage from '../../config/alertMessage';
import { openPDF } from '../../../common/function';
import {autorun} from "mobx";
import userStore from "../../../store/userStore";
/* eslint-disable*/
class FrmNotes extends Component {
  constructor(props) {
    super(props);
    var messageTitle_frm = `<i class="icon-info icons font-2xl d-block "></i>`;

    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_frm,
      MessageContent: AlertMessage.messageContent_frm,
      chapters: [],
      chapters_1: [],
      chapters_2: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      showFreePremium1: '',
      showFreePremium2: '',
      selectedmenu: 'frm',
      pdfLoading1: true,
      pdfLoading2: true,
      lastRecordLevel1: '',
      lastAttemptLevel1: false,
      lastRecordLevel2: '',
      lastAttemptLevel2: false,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  _getReadings = (chapter, e) => {
    'chapter', chapter;

    if (chapter.chapter_no === 1 || chapter.chapter_no === 5) {
      this.context.router.push({
        pathname: `/frm/notesreadings/${chapter.chapter_no}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: chapter.chapter_no,
        },
      });
    } else {
      var data = { token: this.state.token, idname: this.state.idname };
      // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      userStore.getUserProfile(true).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;

            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  const examPlanData = resp_exam.examPlan[0];
                  const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrmNotesSubscription(
                    chapter.level,
                    exam_data,
                    examPlanData
                  );
                  if (subscriptionStatus) {
                    this.context.router.push({
                      pathname: `/frm/notesreadings/${chapter.chapter_no}`,
                      state: {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapter: chapter.chapter_no,
                      },
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                  //console.log('fail');
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            this.toggleAlert();
          } else {
            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var subscriptionStatus = FrmSubscriptionCheck.checkFrmNotesSubscription(
                    chapter.level,
                    exam_data,
                  );
                  if (subscriptionStatus) {
                    this.context.router.push({
                      pathname: `/frm/notesreadings/${chapter.chapter_no}`,
                      state: {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapter: chapter.chapter_no,
                      },
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (localStorage.getItem('selectedmenu') === 'cfa') {
      this.context.router.push({
        pathname: '/dashboard/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChapters', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ ValidToken: true, chapters: resp.chapters });
          var chapters_1_arr = [];
          var chapters_2_arr = [];
          var first_incr = 0;
          var second_incr = 0;
          for (var i = 0; i < resp.chapters.length; i++) {
            if (resp.chapters[i].level === 1) {
              chapters_1_arr[first_incr] = resp.chapters[i];
              first_incr++;
            }
            if (resp.chapters[i].level === 2) {
              chapters_2_arr[second_incr] = resp.chapters[i];
              second_incr++;
            }
          }
          this.setState({
            chapters_1: chapters_1_arr,
            chapters_2: chapters_2_arr,
          });
          await FD.callAPI(App_data.backend_api + '/frm_notes/getlastReadNotesLevel1', data).then(
            response => {
              if (response.success) {
                this.setState({
                  lastRecordLevel1: response.dataLevel1,
                  lastAttemptLevel1: true,
                });
              }
            },
          );
          await FD.callAPI(App_data.backend_api + '/frm_notes/getlastReadNotesLevel2', data).then(
            response => {
              if (response.success) {
                this.setState({
                  lastRecordLevel2: response.dataLevel2,
                  lastAttemptLevel2: true,
                });
              }
            },
          );
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );

    var data = { token: this.state.token, idname: this.state.idname };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
    this.dispose = autorun(async () => {
      const resp = userStore;
      if(resp == null || resp.profileInfo == null) return;

      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium1: true, showFreePremium2: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                var subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrmNotesSubscription(
                  1,
                  exam_data,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.setState({ showFreePremium1: false });
                } else {
                  this.setState({ showFreePremium1: true });
                }
                var exam_data = resp_exam.examData;
                var subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrmNotesSubscription(
                  2,
                  exam_data,
                  examPlanData,
                );

                if (subscriptionStatus) {
                  this.setState({ showFreePremium2: false });
                } else {
                  this.setState({ showFreePremium2: true });
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({ showFreePremium1: true, showFreePremium2: true });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrmNotesSubscription(
                  1,
                  exam_data,
                );
                if (subscriptionStatus) {
                  this.setState({ showFreePremium1: false });
                } else {
                  this.setState({ showFreePremium1: true });
                }

                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrmNotesSubscription(
                  2,
                  exam_data,
                );

                if (subscriptionStatus) {
                  this.setState({ showFreePremium2: false });
                } else {
                  this.setState({ showFreePremium2: true });
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.dispose) this.dispose();
  }

  goToNotesLevel1 = async () => {
    const { lastRecordLevel1, lastAttemptLevel1 } = this.state;
    if (lastAttemptLevel1) {
      this.context.router.push({
        pathname:
          '/frm/beginnotes/' +
          lastRecordLevel1.frm_note.chapter_id +
          '/' +
          lastRecordLevel1.frm_note.reading_id +
          '/' +
          lastRecordLevel1.contentID +
          '/' +
          0 +
          lastRecordLevel1.frmLevel,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecordLevel1.frm_note.chapter_id,
          reading: {
            level: lastRecordLevel1.frmLevel,
            chapter_no: lastRecordLevel1.frm_note.chapter_id,
            id: lastRecordLevel1.frm_note.reading_id,
          },
          offset: 0,
        },
      });
    }
  };

  goToNotesLevel2 = async () => {
    const { lastRecordLevel2, lastAttemptLevel2 } = this.state;
    if (lastAttemptLevel2) {
      this.context.router.push({
        pathname:
          '/frm/beginnotes/' +
          lastRecordLevel2.frm_note.chapter_id +
          '/' +
          lastRecordLevel2.frm_note.reading_id +
          '/' +
          lastRecordLevel2.contentID +
          '/' +
          0 +
          '/' +
          lastRecordLevel2.frmLevel,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecordLevel2.frm_note.chapter_id,
          reading: {
            level: lastRecordLevel2.frmLevel,
            chapter_no: lastRecordLevel2.frm_note.chapter_id,
            id: lastRecordLevel2.frm_note.reading_id,
          },
          offset: 0,
        },
      });
    }
  };

  getAdditionalResources = level => {
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      type: 'Formula sheet',
      exam: level === 1 ? 'frm_1' : 'frm_2',
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getAdditionalResources', data).then(
      resp => {
        console.log('resp--------------------', resp);
        if (resp.success) {
          this.setState({ ValidToken: true });
          openPDF(resp);
          // var myWindow = window.open(resp.data.pdf);
          // myWindow.focus();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  checkSubscription = level => {
    var data = { token: this.state.token, idname: this.state.idname };

    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFormulaSheetSubscription(
                  level,
                  exam_data,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.getAdditionalResources(1);
                  // const getIndex = resp_exam.examdetails.filter(
                  //   (item) => item.exam_name === 'frm'
                  // )[0];
                  // if (getIndex) {
                  //   if (getIndex.formulaSheet) {
                  //     var myWindow = window.open(getIndex.formulaSheet);
                  //   }
                  //   myWindow.focus();
                  // }
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.toggleAlert();
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              //console.log('resp_exam', resp_exam);

              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFormulaSheetSubscription(
                  level,
                  exam_data,
                );
                if (subscriptionStatus) {
                  //console.log('resp_exam.examdetails', resp_exam);
                  let getIndex;
                  if (level === 1) {
                    // getIndex = resp_exam.allexamData.filter(
                    //   (item) => item.exam_name === 'frm'
                    // )[0];
                    this.getAdditionalResources(1);
                  } else {
                    // getIndex = resp_exam.allexamData.filter(
                    //   (item) => item.exam_name === 'frm_2'
                    // )[0];

                    this.getAdditionalResources(2);
                  }
                  //console.log('getIndex', getIndex);
                  // if (getIndex) {
                  //   if (getIndex.formulaSheet) {
                  //     var myWindow = window.open(getIndex.formulaSheet);
                  //   }
                  //   myWindow.focus();
                  // }
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  render() {
    let chapters_1 = this.state.chapters_1;
    let data = '';
    const { lastAttemptLevel1, lastAttemptLevel2 } = this.state;
    if (this.state.chapters_1.length) {
      data = chapters_1.map((item, index) => (
        <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={item.id}>
          <div
            className='question_bank_wrap pointer_class'
            key={item.id}
            onClick={this._getReadings.bind(this, item)}
          >
            {this.state.showFreePremium1 ? (
              item.id === 1 ? (
                <div className='tag-tile free'> {language.LC().FREE} </div>
              ) : (
                <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
              )
            ) : null}
            <div className='margin_bottom_30'>
              <img
                src={App_data.frontend_url + '/img/notes/notes_icon1.svg'}
                className=''
                width='40'
                alt=''
              />
            </div>
            <div className='question_title' key={item.id} value={item.id}>
              <a>
                {/* <a className="pointer_class" id={item.chapter_name} value={item.chapter_no} onClick={this._getReadings.bind(this, item)}>*/}
                {index + 1}. {item.chapter_name}
                {/*</a>*/}
              </a>
            </div>
            <ul key={item.chapter_name}>
              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon2.svg'}
                    className=''
                    width='24'
                    alt=''
                  />
                </span>
                <span>
                  {/*Total Readings:*/} {item.Countreading}
                </span>
                <div className='tootip_box'> {language.LC().CHAPTERS} </div>
              </li>
            </ul>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    let chapters_2 = this.state.chapters_2;
    let data_2 = '';
    if (this.state.chapters_2.length) {
      data_2 = chapters_2.map((item, index) => (
        <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={item.id}>
          <div
            className='question_bank_wrap pointer_class'
            key={item.id}
            onClick={this._getReadings.bind(this, item)}
          >
            {this.state.showFreePremium2 ? (
              item.id === 5 ? (
                <div className='tag-tile free'> {language.LC().FREE} </div>
              ) : (
                <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
              )
            ) : null}
            <div className='margin_bottom_30'>
              <img
                src={App_data.frontend_url + '/img/notes/notes_icon1.svg'}
                className=''
                width='40'
                alt=''
              />
            </div>
            <div className='question_title' key={item.id} value={item.id}>
              <a>
                {/* <a className="pointer_class" id={item.chapter_name} value={item.chapter_no} onClick={this._getReadings.bind(this, item)}>*/}
                {index + 1}. {item.chapter_name}
                {/*</a>*/}
              </a>
            </div>
            <ul key={item.chapter_name}>
              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon2.svg'}
                    className=''
                    width='24'
                    alt=''
                  />
                </span>
                <span>
                  {/*Total Readings:*/} {item.Countreading}
                </span>
                <div className='tootip_box'> {language.LC().CHAPTERS} </div>
              </li>
            </ul>
          </div>
        </div>
      ));
    } else {
      data_2 = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-sm-12 col-md-12 margin_bottom_20 frm_title_logo_wrap'>
            <h1 className='section_head'>{language.LC().FRM_NOTES}</h1>
            <img
              src={App_data.frontend_url + '/img/GARP_logo.png'}
              className='garpLogo'
              alt='full logo'
            />
          </div>
        </div>
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <h1 className='section_head'> {language.LC().FRM_PART_I_CHAPTERS} </h1>
          <div>
            <button
              className='btn btn-primary pointer_class mr-2'
              onClick={() => {
                this.checkSubscription(1);
              }}
            >
              {' '}
              {language.LC().Formula_Sheet}{' '}
            </button>
            {lastAttemptLevel1 ? (
              <button
                className='btn btn-primary pointer_class'
                onClick={this.goToNotesLevel1.bind(this)}
                disabled={!lastAttemptLevel1}
              >
                {' '}
                {language.LC().GO_TO_MY_LAST_NOTES_READ}{' '}
              </button>
            ) : null}
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <h1 className='section_head'> {language.LC().FRM_PART_II_CHAPTERS} </h1>
          <div>
            <button
              className='btn btn-primary pointer_class mr-2'
              onClick={() => {
                this.checkSubscription(2);
              }}
            >
              {' '}
              {language.LC().Formula_Sheet}{' '}
            </button>
            {lastAttemptLevel2 ? (
              <button
                className='btn btn-primary pointer_class'
                onClick={this.goToNotesLevel2.bind(this)}
                disabled={!lastAttemptLevel2}
              >
                {' '}
                {language.LC().GO_TO_MY_LAST_NOTES_READ}{' '}
              </button>
            ) : null}
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data_2}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}

export default FrmNotes;



// WEBPACK FOOTER //
// ./src/views/FRM/FrmNotes/FrmNotes.js